import { defineStore } from "pinia";
import axios from "@/app/plugins/axios";
import { useSnackBarStore } from "@/shared/stores/snackbar";
import i18n from "@/app/plugins/i18n";
import {
  BundleProductTagsState,
  BundleProductTag,
  ProductTagItem,
} from "@/catalog/types/productTags";
import { getErrorMessage } from "@/shared/utils/errorMessage";

export const useBundleProductTagsStore = defineStore("bundleProductTags", {
  state: (): BundleProductTagsState => ({
    productTags: {},
    loading: false,
    error: undefined,
  }),

  getters: {
    isLoading: (state) => state.loading,
    getProductTags: (state) => state.productTags,

    // Get flattened array of product tags with active status
    getActiveProductTags: (state): ProductTagItem[] => {
      const result: ProductTagItem[] = [];

      // Iterate through product tags and filter active ones
      Object.entries(state.productTags).forEach(([tagId, tag]) => {
        if (tag.active) {
          const tagItem: ProductTagItem = {
            id: tagId,
            name: tag.name,
            hexColor: tag.hexColor,
            active: tag.active,
            images: tag.images,
          };
          result.push(tagItem);
        }
      });

      return result;
    },
  },

  actions: {
    async fetchProductTags() {
      try {
        this.loading = true;
        this.error = undefined;

        const response = await axios.get<Record<string, BundleProductTag>>("/bundle/productTags");
        this.productTags = response.data || {};

        return this.productTags;
      } catch (error) {
        this.error = getErrorMessage(error, i18n.global.t("common.action.fetchFailed"));
        useSnackBarStore().toastError({
          message: this.error,
        });
        return {};
      } finally {
        this.loading = false;
      }
    },
  },
});
